<template>
    <section id="company" class="company">
        <div class="company__content">
            <p class="centered-text">
                We are proficient in agile methodologies.
                <br>
                We are pragmatic and practical. 
                <br>
                We do like keeping things simple. 
                <br>
                We believe software solutions are products comparable to other tangible goods. 
                <br>
                Contact us today and build your success story with TripTopTrip!
            </p>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'company',
    }
</script>

<style lang="scss" scoped>
    .company {
        padding: 400px 0;
        width: 100%;
        display: flex;
        position: relative;

        &__content {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;
            width: 100%;
        }
    }

    @media all and (max-width: 1200px) {
        .company {
            padding: 300px 0;
        }
    }

    @media all and (max-width: 830px) {
        .company {
            padding: 150px 0;
        }
    }

    @media all and (max-width: 530px) {
        .company {
            padding: 100px 0;
        }
    }

</style>